module.exports = __webpack_public_path__ + "img/logo-1.9099f651.png";